import { connect } from 'react-redux';
import ValueProps from './ValueProps';

const mapStateToProps = ({
  system: { isTablet },
  content: { valueProps }
}) => ({
  isTablet,
  ...valueProps
});

export default connect(mapStateToProps, null)(ValueProps);
